import { atom } from 'jotai';

export const mobileNotificationsOpenAtom = atom(false);
